<template>
  <div class='main'>
    <div class='model' style="margin-top: 15vh;">
      <span class='title'>手持机下载地址：</span>
      <span class='content'>{{ baseUrl }}</span>
      <span class='text' @click='download(1)'>下载</span>
      <!--      <el-tooltip placement='right' effect='light'>
              <div slot='content'>
                <p class='hint-title'>安装步骤</p>
                <div class='hint-content'>
                  <p>1、XXXXXX</p>
                  <p>2、XXXXXX</p>
                  <p>3、XXXXXX</p>
                  <p>4、XXXXXX</p>
                  <p>5、XXXXXX</p>
                </div>
              </div>
              <span class='icon el-icon-question'></span>
            </el-tooltip>-->
    </div>
    <div class='model'>
      <span class='title'>app下载地址：</span>
      <span class='content'>{{appDownloadAddress}}</span>
      <span class='text' @click='download(2)'>下载</span>
    </div>
    <div class='model'>
      <!--      <img alt='' src='https://www.pgyer.com/app/qrcode/JhaI'>-->
      <div id='qrcodeDom' class="qrCodeDiv">
        <div style="margin-bottom: 1vh">
          手持机下载二维码
        </div>
      </div>
      <div id='appDownload' class="qrCodeDiv">
        <div style="margin-bottom: 1vh">
          app下载二维码
        </div>
      </div>
      <div id='appletDownload' class="qrCodeDiv">
        <div style="margin-bottom: 1vh">
          <span>小程序二维码</span>
          <el-image style="width: 210px" :src="imageSrc" />
        </div>
      </div>
      <div id='scanVerificationCode' class="qrCodeDiv">
        <div style="margin-bottom: 1vh">
          <span>扫描验证码</span>
          <el-image style="width: 210px" :src="imageSrc1" />
        </div>
      </div>
      <!--      <img alt='' src='https://www.pgyer.com/app/qrcode/JhaI'>-->
    </div>
  </div>
</template>

<script>
  import { baseUrl } from '@/config/env';
  import QRCode from 'qrcodejs2';

  export default {
    data() {
      return {
        baseUrl: '',
        appDownloadAddress: '',
        imageSrc: '',
        imageSrc1: ''
      };
    },
    mounted() {
      this.transQrcode();
      this.appletDownload()
      this.scanVerificationCode()
    },
    methods: {
      download(val) {
        if (val == 1) {
          window.location.href =  this.baseUrl
          console.log('手持机下载');
        } else {
          window.location.href = this.appDownloadAddress
          console.log('app下载');
        }
      },
      //小程序二维码
      async appletDownload() {
        this.imageSrc = await require('/src/assets/applet.jpg');
      },
      //扫描验证码
      async scanVerificationCode() {
        this.imageSrc1 = await require('/src/assets/scanVerificationCode.png');
      },
      transQrcode() {
        // 1 手持机 2 APP
        this.baseUrl = `${baseUrl}/platform/handset/apkDownload?handsetOrPhone=1`;
        this.appDownloadAddress = `${baseUrl}/platform/handset/apkDownload?handsetOrPhone=2`
        let qrcode = new QRCode('qrcodeDom', {
          width: 210,
          height: 210,
          text: `${baseUrl}#/handheldDownload?handsetOrPhone=1`,  //需要转换的链接
          // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
          // background: '#f0f',   // 背景色
          // foreground: '#ff0'    // 前景色
        });
        let appDownload = new QRCode('appDownload', {
          width: 210,
          height: 210,
          text: `${baseUrl}#/handheldDownload?handsetOrPhone=2`,
        });
      },
    },
  };
</script>

<style lang='scss' scoped>


  .main {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .model {
      width: 850px;
      margin-top: 3vh;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      .qrCodeDiv{
        margin: 4vh;
        font-size: 16px;
        font-weight: 700;
        vertical-align: top;
        text-align: center;
      }
      .title {
        display: inline-block;
        width: 130px;
        text-align: right;
        font-size: 16px;
        font-weight: 700;
        vertical-align: top;
      }

      .content {
        display: inline-block;
        width: 220px;
        word-break: keep-all;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #467dd1;
        font-size: 14px;
        text-decoration: underline;
        vertical-align: top;
      }

      .text {
        display: inline-block;
        width: 50px;
        text-align: center;
        color: #5a759b;
        cursor: pointer;
        vertical-align: top;
      }

      .icon {
        display: inline-block;
        position: relative;
        top: 5px;
        width: 25px;
        text-align: center;
        font-size: 18px;
        vertical-align: top;
      }

      img {
        display: inline-block;
        width: 210px;
      }

      img:first-child {
        margin-right: 30px;
      }
    }
  }

  .hint-title {
    display: inline-block;
    width: 100%;
    font-size: 18px;
    font-weight: 700;
    padding: 10px 20px;
    text-align: center;
  }

  .hint-content {
    display: inline-block;
    width: 100%;
    font-size: 14px;
    line-height: 20px;
    padding: 10px 20px;
  }
</style>
